import React, {useEffect, useState} from "react";
import {EsignerRole} from "../../../../Common/Constant";
import {Container, Form, Modal, Row} from "react-bootstrap";
import {SelectInput, TextInput} from "../../../../Helpers/Inputs";
import {InputMaskPhone} from "../../../../Helpers/Formatters";
import {Button, IconButton} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {makeStyles} from "@material-ui/core/styles";

const ESignerForm = (props) => {
  const classes = useStyles();

  const {register, errors, formState} = props;
  const {esigner: signer} = formState;

  const [show, setShow] = useState(false);

  const selectedRoles = (
    signer[props.index].role === EsignerRole.OWNER ||
    signer[props.index].role === EsignerRole.PRIMARY_OWNER ||
    signer[props.index].role === EsignerRole.JOINT_OWNER ||
    signer[props.index].role === EsignerRole.AUTHORIZED_INDIVIDUAL ||
    signer[props.index].role === EsignerRole.TRUSTEE
  );

  const onFieldChange = (field, value) => {
    props.onChange({...signer[props.index], [field]: value})
  }

  const handleValueChange = (field, value, longFieldName) => {
    props.setValue(longFieldName, value)
    props.trigger(longFieldName);
    onFieldChange(field, value);
  }

  useEffect(() => {
    if (signer[props.index].missingContact) {
      props.setIsNextDisabled(true);
    }
  }, [signer])

  return (
    <div>
      <h6><b>{signer[props.index].role}</b></h6>
      <Form.Group>
        <TextInput
          name={`esigner[${props.index}].firstName`}
          id={`esigner[${props.index}].firstName`}
          value={signer[props.index].firstName || ''}
          onChange={(e) => handleValueChange('firstName', e.target.value, `esigner[${props.index}].firstName`)}
          label="First Name"
          errors={errors && errors.firstName}
          inputRef={register}
          disabled={true}
        />
      </Form.Group>
      <Form.Group>
        <TextInput
          name={`esigner[${props.index}].lastName`}
          id={`esigner[${props.index}].lastName`}
          label="Last Name"
          value={signer[props.index].lastName || ''}
          errors={errors && errors.lastName}
          inputRef={register}
          onChange={(e) => handleValueChange('lastName', e.target.value, `esigner[${props.index}].lastName`)}
          disabled={true}
        />
      </Form.Group>

      {signer[props.index] && signer[props.index].phoneList.length > 1 ? (
        <Form.Group>
        <SelectInput
          name={`esigner[${props.index}].phone`}
          id={`esigner[${props.index}].phone`}
          value={signer[props.index].phone || ''}
          onChange={(e) => handleValueChange('phone', e.target.value, `esigner[${props.index}].phone`)}
          label="Phone"
          selectOptions={signer[props.index].phoneList}
          errors={errors && errors.phone}
          inputRef={register}
        />
      </Form.Group>
      ) : (
        <Form.Group>
          <TextInput
            name={`esigner[${props.index}].phone`}
            id={`esigner[${props.index}].phone`}
            value={signer[props.index].phone || ''}
            label="Phone"
            errors={errors && errors.phone}
            inputRef={register}
            onChange={(e) => handleValueChange('phone', e.target.value, `esigner[${props.index}].phone`)}
            InputProps={{
              inputComponent: InputMaskPhone,
            }}
            disabled={true}
          />
        </Form.Group>
      )}



{/*      {signer[props.index].role === EsignerRole.PRIMARY_OWNER ||
      signer[props.index].role === EsignerRole.OWNER ||
      signer[props.index].role === EsignerRole.JOINT_OWNER ||
      (signer[props.index].role === EsignerRole.FINANCIAL_ADVISOR && signer[props.index].phone) ?
        (signer[props.index] && signer[props.index].phoneList.length > 1 ?
          <Form.Group>
            <SelectInput
              name={`signer[${props.index}].phone`}
              id={`signer[${props.index}].phone`}
              value={signer[props.index].phone || ''}
              onChange={(e) => handleValueChange('phone', e.target.value, `signer[${props.index}].phone`)}
              label="Phone"
              selectOptions={signer[props.index].phoneList}
              errors={errors && errors.phone}
              inputRef={register}
            />
          </Form.Group>
          :
          <Form.Group>
            <TextInput
              label="Phone"
              disabled={true}
            />
          </Form.Group>)
        :
        <Form.Group>
          <TextInput
            name={`signer[${props.index}].phone`}
            id={`signer[${props.index}].phone`}
            value={signer[props.index].phone || ''}
            label="Phone"
            errors={errors && errors.phone}
            inputRef={register}
            onChange={(e) => handleValueChange('phone', e.target.value, `signer[${props.index}].phone`)}
            InputProps={{
              inputComponent: InputMaskPhone,
            }}
            disabled={true}
          />
        </Form.Group>
      }*/}

      {signer[props.index] && signer[props.index].emailList.length > 1 ? (
        <Form.Group>
          <SelectInput
            name={`esigner[${props.index}].email`}
            id={`esigner[${props.index}].email`}
            value={signer[props.index].email || ''}
            onChange={(e) => handleValueChange('email', e.target.value, `esigner[${props.index}].email`)}
            label="Email"
            selectOptions={signer[props.index].emailList}
            errors={errors && errors.email}
            inputRef={register}
          />
        </Form.Group>
      ) : (
        <Form.Group>
          <TextInput
            name={`esigner[${props.index}].email`}
            id={`esigner[${props.index}].email`}
            value={signer[props.index].email || ''}
            onChange={(e) => handleValueChange('email', e.target.value, `esigner[${props.index}].email`)}
            label="Email"
            errors={errors && errors.email}
            inputRef={register}
            disabled={true}
          />
        </Form.Group>
      )}

      {/*      {signer[props.index].role === EsignerRole.PRIMARY_OWNER ||
      signer[props.index].role === EsignerRole.OWNER ||
      signer[props.index].role === EsignerRole.JOINT_OWNER ?
        (signer[props.index] && signer[props.index].emailList.length > 1 ?
            <Form.Group>
              <SelectInput
                name={`signer[${props.index}].emails`}
                id={`signer[${props.index}].emails`}
                value={signer[props.index].email || ''}
                onChange={(e) => handleValueChange('email', e.target.value, `signer[${props.index}].email`)}
                label="Email"
                selectOptions={signer[props.index].emailList}
                errors={errors && errors.email}
                inputRef={register}
              />
            </Form.Group>
            :
            <Form.Group>
              <TextInput
                label="Email"
                disabled={true}
              />
            </Form.Group>
        )
        :
        <Form.Group>
          <TextInput
            name={`signer[${props.index}].email`}
            id={`signer[${props.index}].email`}
            value={signer[props.index].email || ''}
            onChange={(e) => handleValueChange('email', e.target.value, `signer[${props.index}].email`)}
            label="Email"
            errors={errors && errors.email}
            inputRef={register}
            disabled={true}
          />
        </Form.Group>
      }*/}

      {signer[props.index].role !== "Proposed Insured" && signer[props.index].missingContact ?
        <Form.Group>
          <TextInput
            label="Authentication"
            name={`esigner[${props.index}].authentication`}
            id={`esigner[${props.index}].authentication`}
            onChange={() => {}}
            disabled={true}
          />
        </Form.Group>
        :
        <Form.Group>
          <SelectInput
            name={`esigner[${props.index}].authentication`}
            id={`esigner[${props.index}].authentication`}
            label="Authentication"
            value={signer[props.index].authentication || ''}
            errors={errors && errors.authentication}
            inputRef={register}
            onChange={(e) => handleValueChange('authentication', e.target.value, `esigner[${props.index}].authentication`)}
            selectOptions={[
              {value: 'Phone', label: 'Phone Call'},
              {value: 'SMS', label: 'Text Message'},
            ]}
          />
        </Form.Group>
      }
      {
        selectedRoles ?
          <div>
            <Row className='mb-3 text-center justify-content-center'>
              <Button className="ml-4" variant="contained" size="medium" color="primary" onClick={() => setShow(true)}>
                Update
              </Button>
              <Button className="ml-2" variant="contained" size="medium" color="primary" onClick={props.reloadEsigner}>
                Refresh
              </Button>
            </Row>
            {signer[props.index].missingContact &&
              <div className='alert alert-danger'>
                This signer is missing an email address or phone number in Morgan Stanley Webnas. Please request an
              update in Webnas and then click refresh. Changes to the contact info can be made in the account’s 3D profile
              may take approximately 24 hours to update.
              </div>
            }
            {!signer[props.index].missingContact && props.isRefresh &&
              <div className='alert alert-warning'>
              This signer is missing an email address or phone number in Morgan Stanley Webnas. Please update in Webnas. 
              Create a brand new ticket and click refresh. Changes to the contact info can be made in the account’s 3D profile may take approximately 24 hours to update.
            </div>
            }
          </div> : null
      }

      <Modal className="insured-info-content" size="lg" show={show} onHide={() => setShow(false)} animation={false}
             centered>
        <Modal.Body className="d-flex align-items-center p-4 flex-column">
          <Container>
            <div className='head-close'>
              <h5 className={classes.blueText}>How to Update Client Contact Information</h5>
              <IconButton className="close-button" aria-label="close" onClick={() => setShow(false)}>
                <CloseIcon/>
              </IconButton>
            </div>
            <Row className='px-4'>
              <p className='mb-2 mt-3'>Changes to contact info made in 3D profile may take approximately 24 hours to update</p>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  blueText: {
    color: `${theme.palette.primary.main}`,
  },
}));

export default ESignerForm;


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/ESign/SubComponents/ESignerForm.js